import React from "react";
import {
  Alert,
  Box, CircularProgress,
  Paper
} from "@mui/material";
import { TranslationEditor } from "components/TranslationEditor";
import { useDetailPage, DetailHeading } from "pages/Common";
import apiEndpoints from "constants/endpoints";

interface EventTypeI18n {
  lang: string;
  label: string;
  id: number;
}

export const EventTypeDetail = () => {
  const {
    id,
    data,
    loading,
    saving,
    onSave,
    onUpdateData,
  } = useDetailPage({
    apiEndpoint: apiEndpoints.eventTypes,
    autoI18nFromEnglish: true,
    defaultData: {
      sportId: 5,
    }
  });
  const name = data && data.i18n ? data.i18n.find((item: EventTypeI18n) => item.lang === 'en').label : null;

  return (
    <Paper>
      <Box p={2}>
        {loading &&
          <Box height="100vh" display="flex" alignItems="center" justifyContent="center">
            <CircularProgress />
          </Box>
        }
        {!!data &&
          <>
            <DetailHeading
              listLink={apiEndpoints.eventTypes}
              listName="Event Types"
              title={id === 'new' ? "New Event Type" : name}
              saving={saving}
              onSave={onSave}
            />
            <Paper sx={{ padding: 2 }}>
              <Alert severity="info">
                <strong>English</strong> is the default content. If there are any missing translations, they will be <strong>replaced with the English version automatically</strong> when saving.
              </Alert>
              <TranslationEditor
                i18n={data.i18n}
                inputs={[
                  {field: 'label', type: 'text', label: 'Name', fullWidth: false},
                ]}
                onUpdate={(i18n) => onUpdateData({i18n})}
              />
            </Paper>
          </>
        }
      </Box>
    </Paper>
  )
};
